import { fetchFromUrlPOSTAsync } from '../fetch/';

export const actions = {

  getRequestsList: async () => {
    const result = await fetchFromUrlPOSTAsync('/diagnosis_request/get_grouped_list', []);
    return result.success ? result.data : [];
  },
};
